// Types that can be checked for.
type TypeMapBasicTypes = 'number' | 'string' | 'boolean' | 'undefined' | 'null';
type TypeMapRecursiveTypes =  'object' | 'array';
// Types of checks that can occur.
interface IBasicValueCheck {
    value: any
}
const isIBasicValueCheck = (typeInfo: any): typeInfo is IBasicValueCheck => (typeInfo.hasOwnProperty('value'));
interface IBasicTypeCheck {
    type: TypeMapBasicTypes | Array<TypeMapBasicTypes>
}
const isIBasicTypeCheck = (typeInfo: any): typeInfo is IBasicTypeCheck => (typeInfo.hasOwnProperty('type') && !typeInfo.hasOwnProperty('guard'));
interface IRecursiveTypeCheck {
    type: TypeMapRecursiveTypes,
    guard(obj: any): boolean
}

export type TypeGuardAssertionTypeMap = {
    [key: string]: IBasicTypeCheck | IBasicValueCheck | IRecursiveTypeCheck;
}

export function typeGuardAssertion<T>(obj: any, typeMap: TypeGuardAssertionTypeMap): obj is T {
    // Try to fail every field:
    // if any fails, return false;
    // if all pass, finish loop and return true;
    for (const [field, typeInfo] of Object.entries(typeMap)) {
        // Basic value check.
        if (isIBasicValueCheck(typeInfo)) {
            // List of values check.
            if (Array.isArray(typeInfo.value)) {
                if (typeInfo.value.includes(obj[field])) {
                    continue;
                } else {
                    return false;
                }
            }
            // Single value check.
            else {
                // Fails if field is not the value provided.
                if (obj[field] !== typeInfo.value) {
                    return false;
                } else {
                    continue;
                }
            }
        } 
        // Basic type check.
        else if (isIBasicTypeCheck(typeInfo)) {
            const typeofObjectField = (obj[field] === null)
                ? 'null'
                : typeof obj[field];
            // Check if list of applicable types:
            if (Array.isArray(typeInfo.type)) {
                const typeList: Array<string> = [...typeInfo.type]
                // Type is not in list
                if (!typeList.includes(typeofObjectField)) {
                    return false;
                } else {
                    continue;
                }
            }
            // Only one applicable type
            else {
                if (typeofObjectField !== typeInfo.type) {
                    // Type is not the same
                    return false;
                } else {
                    continue;
                }
            }
        }
        // Recursive type check.
        else {
            // Field is an object.
            if (typeInfo.type === 'object') {
                if (typeInfo.guard(obj[field])) {
                    continue;
                } else {
                    return false;
                }
            }
            // Field is an array.
            else {
                if (Array.isArray(obj[field])) {
                    for (const item of obj[field]) {
                        if (typeInfo.guard(item)) {
                            continue;
                        } else {
                            return false;
                        }
                    }
                    continue;
                } else {
                    return false;
                }
            }
        }
    }
    return true;
}